import React from 'react';
import { ChevronRight, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
// Helper component for the score display
interface CircularScoreProps {
  score: number;
  size?: number;
  strokeWidth?: number;
  className?: string;
}
export function CircularScore({
  score,
  className = ''
}: CircularScoreProps) {
  const label = score >= 90 ? 'Eccellente' : score >= 70 ? 'Buono' : score >= 50 ? 'Sufficiente' : 'Scarso';
  const labelColor = score >= 90 ? 'text-emerald-600' : score >= 70 ? 'text-amber-600' : score >= 50 ? 'text-orange-600' : 'text-red-600';
  return <div className={`flex flex-col items-end ${className}`} data-id="element-89">
      <span className="flex items-baseline gap-0.5" data-id="element-90">
        <span className="text-2xl font-bold text-pink-500 leading-none" data-id="element-91">
          {score}
        </span>
        <span className="text-xs text-muted-foreground" data-id="element-92">/100</span>
      </span>
      <span className="text-[11px] font-medium mt-1 text-muted-foreground" data-id="element-93">
        {score >= 90 ? 'Qualità eccellente' : score >= 70 ? 'Buona qualità' : score >= 50 ? 'Qualità sufficiente' : 'Qualità da migliorare'}
      </span>
    </div>;
}
export function LastCleaningWidget() {
  return <div className="mb-8" data-id="element-94">
      <h2 className="text-sm font-semibold text-foreground mb-3" data-id="element-95">
        Ultima pulizia eseguita
      </h2>

      <div className="bg-white border border-border rounded-xl overflow-hidden" data-id="element-96">
        <Link to="/pulizia-dettaglio" className="flex items-center gap-4 p-4 hover:bg-muted/30 transition-all" data-id="element-97">
          {/* Date block */}
          <div className="flex-shrink-0 w-14 text-center border border-border rounded-lg py-2 px-1.5" data-id="element-98">
            <div className="text-[10px] uppercase tracking-wider font-medium text-muted-foreground" data-id="element-99">
              Oggi
            </div>
            <div className="text-2xl font-bold text-foreground leading-tight" data-id="element-100">
              15
            </div>
            <div className="text-[11px] text-muted-foreground" data-id="element-101">Gen</div>
          </div>

          {/* Info column */}
          <div className="flex-1 min-w-0" data-id="element-102">
            <div className="text-sm font-semibold text-foreground" data-id="element-103">
              10:30 – 13:00
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground mt-1" data-id="element-104">
              <img src="https://cdn.magicpatterns.com/uploads/g4qUZyyXcdzW3wf29pvDcz/Screenshot_2026-03-22_alle_16.12.18.png" alt="Francesca N." className="w-8 h-8 rounded-full object-cover flex-shrink-0" data-id="element-105" />
              Francesca N. · 2h 30m
            </div>
          </div>

          {/* Right column – score */}
          <CircularScore score={98} data-id="element-106" />

          {/* Chevron hint */}
          <ChevronRight size={18} className="text-muted-foreground flex-shrink-0" data-id="element-107" />
        </Link>

        {/* Footer: Checklist progress */}
        <div className="flex items-center justify-between px-4 py-3 border-t border-border" data-id="element-108">
          <div className="flex items-center gap-2 flex-shrink-0" data-id="element-109">
            <CheckCircle size={18} className="text-foreground" data-id="element-110" />
            <span className="text-sm text-foreground font-medium" data-id="element-111">
              Checklist
            </span>
            <span className="text-xs text-muted-foreground font-medium bg-muted rounded-full px-2 py-0.5" data-id="element-112">
              12/12
            </span>
          </div>

          <Link to="/pulizia-dettaglio" className="flex items-center gap-1 text-sm font-semibold text-foreground bg-white border border-border rounded-full px-3 py-1.5 hover:bg-muted transition-colors flex-shrink-0" data-id="element-113">
            Dettaglio
            <ChevronRight size={16} data-id="element-114" />
          </Link>
        </div>
      </div>
    </div>;
}